import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

export default class TiktokProvider extends HttpRequest {
  getCategoryList (query) {
    this.setHeader(getAuthToken())
    return this.get('/tiktok/products/category/list', query)
  }

  getAttributeList (query) {
    this.setHeader(getAuthToken())
    return this.get('/tiktok/products/attribute/list', query)
  }

  getRecommendCategoryList (body) {
    this.setHeader(getAuthToken())
    return this.post('/tiktok/products/category/recommend/list', body)
  }

  getProductList (query) {
    this.setHeader(getAuthToken())
    return this.get('/tiktok/products', query)
  }

  getProductDetail (id, query) {
    this.setHeader(getAuthToken())
    return this.get(`/tiktok/products/${id}`, query)
  }

  getDeliveryOptionList (query) {
    this.setHeader(getAuthToken())
    return this.get('/tiktok/products/warehouse-delivery-option/list', query)
  }

  getBrandList (query) {
    this.setHeader(getAuthToken())
    return this.get('/tiktok/products/brand/list', query)
  }

  getWarehouseList (query) {
    this.setHeader(getAuthToken())
    return this.get('/tiktok/products/warehouse/list', query)
  }

  getAuthorizedShop (query) {
    this.setHeader(getAuthToken())
    return this.get('/tiktok/authorized-shops', query)
  }

  deleteProduct (id, query) {
    this.setHeader(getAuthToken())
    return this.delete(`/tiktok/products/${id}?brand=${query.brand}`)
  }

  createProduct (data) {
    this.setHeader(getAuthToken())
    return this.post('/tiktok/products', data)
  }

  updateProduct (id, data) {
    this.setHeader(getAuthToken())
    return this.put(`/tiktok/products/${id}`, data)
  }

  syncProductStock (data) {
    this.setHeader(getAuthToken())
    return this.post('/tiktok/inventories/sync', data)
  }

  syncAllProductStock (data) {
    this.setHeader(getAuthToken())
    return this.post('/tiktok/products/sync-all-stock', data)
  }

  getRequestLogs (query) {
    this.setHeader(getAuthToken())
    return this.get('/tiktok-request-logs', query)
  }

  getWebhookLogs (query) {
    this.setHeader(getAuthToken())
    return this.get('tiktok/webhook', query)
  }

  getTiktokOrderError (query) {
    this.setHeader(getAuthToken())
    return this.get('tiktok/order-error-logs', query)
  }

  reproduce (body) {
    this.setHeader(getAuthToken())
    return this.post('tiktok/order-error-logs/reproduce', body)
  }

  getReturnOrder (query) {
    this.setHeader(getAuthToken())
    return this.get('tiktok/return-orders', query)
  }

  getOrders (query) {
    this.setHeader(getAuthToken())
    return this.get('tiktok/orders', query)
  }

  syncWaitingOrder (body) {
    this.setHeader(getAuthToken())
    return this.post('tiktok/orders/sync-paid', body)
  }

  syncCancelOrder (body) {
    this.setHeader(getAuthToken())
    return this.post('tiktok/orders/sync-cancel', body)
  }

  getTokenLogs (query) {
    this.setHeader(getAuthToken())
    return this.get('/tiktok-token-logs', query)
  }

  refreshToken (id) {
    this.setHeader(getAuthToken())
    return this.post(`/tiktok-token-logs/refresh/${id}`)
  }

  connectShop (data) {
    this.setHeader(getAuthToken())
    return this.post('/public/tiktok/connect-store', data)
  }
}
